import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/att/app/node_modules/next/dist/client/app-dir/link.js");
